import { Component } from '@angular/core';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrl: './product.component.scss',
    standalone: false
})
export class ProductComponent {

}
